import React from "react";
import { IconButton } from "@strapi/design-system/IconButton";
import ChevronLeft from "@strapi/icons/ChevronLeft";
import ChevronRight from "@strapi/icons/ChevronRight";
import { Typography } from "@strapi/design-system/Typography";
import styles from "./Pagination.module.css";
const Pagination = ({
  activePage,
  isLoading,
  maxPage,
  onPageChange
}) => {
  const handlePageChange = input => {
    if (!isLoading) onPageChange(input);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.pagination
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => handlePageChange(-1),
    icon: /*#__PURE__*/React.createElement(ChevronLeft, null),
    disabled: activePage === 1
  }), /*#__PURE__*/React.createElement("div", {
    className: styles["page-label"]
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "omega",
    fontWeight: "bold"
  }, "Page ", activePage, " of ", maxPage)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => handlePageChange(1),
    icon: /*#__PURE__*/React.createElement(ChevronRight, null),
    disabled: activePage === maxPage
  }));
};
export default Pagination;